import barba from "transitions";
import { initBlobs } from "./blobs";
import { initMenu } from "./animations";
import "normalize.css";

barba();
initBlobs();
initMenu();
